import { createSelector } from 'reselect'

/**
 * Select the message state slice
 * @param {object} state - Redux state
 * @returns {object} Message state
 */
export const selectMessage = (state) => state.message

/**
 * Select whether a message send is in progress
 * @param {object} state - Redux state
 * @returns {boolean} Awaiting message status
 */
export const selectIsAwaitingMessage = createSelector(
  selectMessage,
  (message) => message.isAwaitingMessage
)

/**
 * Select the messages queued to send
 * @param {object} state - Redux state
 * @returns {Array} Messages to send
 */
export const selectMessagesToSend = createSelector(
  selectMessage,
  (message) => message.messagesToSend
)
